import { Box, CircularProgress, Typography } from "@mui/material";
import { useSiteTranslation } from "../pages/home/i18n";

/** Full-screen loading state in the dashboard's espresso and gold colours. */
export default function PageLoader({ label }) {
  const { t, language, dir } = useSiteTranslation();
  return (
    <Box
      dir={dir}
      lang={language}
      role="status"
      aria-live="polite"
      sx={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        alignContent: "center",
        gap: 2,
        bgcolor: "#1d1915",
        color: "rgba(245, 239, 227, 0.62)",
      }}
    >
      <CircularProgress size={34} thickness={3} sx={{ color: "#c7a45d" }} />
      <Typography
        sx={{
          fontSize: 13,
          letterSpacing: language === "ar" ? 0 : ".08em",
          fontFamily: language === "ar" ? '"IBM Plex Sans Arabic", sans-serif' : undefined,
        }}
      >
        {label || t("common.loading")}
      </Typography>
    </Box>
  );
}
